(function () {
	const initProductAccordion = () => {
		$(".product-about__accordion-title").click(function () {
			if (!$(this).hasClass("active")) {
				$(".product-about__accordion-title.active").removeClass("active");
				$(this).addClass("active");
				$(".product-about__accordion-content").stop().slideUp(300);
				if($(this).siblings(".product-about__accordion-content").length > 0) {
					$(this)
						.siblings(".product-about__accordion-content")
						.eq($(this).index())
						.stop()
						.slideDown(300);
				} else {
					let data_id = $(this).attr('data-id');
					console.log('data_id',data_id);
					$('#'+data_id).stop().slideDown(300);
				}
			} else if ($(this).is('[data-id]') == false) {
				$(this).removeClass("active");
				$(this).siblings(".product-about__accordion-content").stop().slideUp(300);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
